import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, HostBinding, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";
import { v4 as uuidv4 } from 'uuid';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Observable, Subject, map } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Stats } from "src/app/models/stats.model";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { onSnapshot } from "firebase/firestore";
import { TabViewChangeEvent } from "primeng/tabview";
import { environment } from "src/environments/environment";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-prontofibra",
  templateUrl: "./home.prontofibra.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeProntofibraFlowdy2Component implements OnInit, OnChanges {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isDemo: boolean = null;
  ref: DynamicDialogRef;

  protected praticheBando1Totali = 100;
  protected praticheBando1InLavorazione = 20;

  protected praticheBando2Totali = 200;
  protected praticheBando2InLavorazione = 40;

  protected isLoading: boolean = false;
  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  protected isPresidioSF : boolean = false;
  
  protected isDipendente: boolean = true;
  protected hasBando1: boolean = false;
  protected hasBando2: boolean = false;

  protected bando1:number = 0;
  protected bando1InLavorazione:number = 0;
  protected bando1KO:number = 0;
  protected bando1KO_lotto6:number = 0;
  protected bando1KO_lotto7:number = 0;

  protected bando1InAttesa:number = 0;
  protected bando1InAttesa_lotto6:number = 0;
  protected bando1InAttesa_lotto7:number = 0;
  protected bando1Pronte:number = 0;
  protected bando1Pronte_lotto6:number = 0;
  protected bando1Pronte_lotto7:number = 0;
  protected bando1RouterInstallato:number = 0;
  protected bando1RouterInstallato_lotto6:number = 0;
  protected bando1RouterInstallato_lotto7:number = 0;
  protected bando1Attivate:number = 0;
  protected bando1Attivate_lotto6:number = 0;
  protected bando1Attivate_lotto7:number = 0;

  protected bando2:number = 0;
  protected bando2InLavorazione:number = 0;
  protected bando2InAttesa:number = 0;
  protected bando2InAttesa_lotto1:number = 0;
  protected bando2InAttesa_lotto5:number = 0;
  protected bando2InAttesa_lotto7:number = 0;
  protected bando2InAttesa_lotto8:number = 0;
  protected bando2KO:number = 0;
  protected bando2KO_lotto1:number = 0;
  protected bando2KO_lotto5:number = 0;
  protected bando2KO_lotto7:number = 0;
  protected bando2KO_lotto8:number = 0;


  protected bando2Pronte:number = 0;
  protected bando2Pronte_lotto1:number = 0;
  protected bando2Pronte_lotto5:number = 0;
  protected bando2Pronte_lotto7:number = 0;
  protected bando2Pronte_lotto8:number = 0;

  protected bando2RouterInstallato:number = 0;
  protected bando2RouterInstallato_lotto1:number = 0;
  protected bando2RouterInstallato_lotto5:number = 0;
  protected bando2RouterInstallato_lotto7:number = 0;
  protected bando2RouterInstallato_lotto8:number = 0;

  protected bando2Attivate:number = 0;
  protected bando2Attivate_lotto1:number = 0;
  protected bando2Attivate_lotto5:number = 0;
  protected bando2Attivate_lotto7:number = 0;
  protected bando2Attivate_lotto8:number = 0;

  private importID: string; 

  private collection_prontofibra:string = environment.firebase.collection_prontofibra;
  private collection_importLog:string = environment.firebase.collection_import_log;

  private csvbox_licenseKey_aggiornaPF:string=environment.csvBox.secret_aggiornaPF;
  private csvbox_importer_aggiornamentoPF:any;


  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    
    @Inject(DOCUMENT) private doc: Document
  ) {
    this.setUserRole();
  }

  setUserRole(){
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }

  ngOnInit() {
    this.logger.info("[HOME PF] ON INIT");
    this.initCSVBox();
  }

  initCSVBox(){
    this.csvbox_importer_aggiornamentoPF = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPF, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.readImportLog();
       
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di aggiornamento dei prontofibra', life:10000});
      }
    });
    
    this.csvbox_importer_aggiornamentoPF.setUser({
      user_id: "default123"
    });
    
   
    this.csvbox_importer_aggiornamentoPF.language="it";
  }

  readImportLog(){
    const collectionRef = this.firestore.collection(this.collection_importLog).ref;
    let queryErrori ;
    queryErrori = collectionRef
              .where("id", "==", this.importID);
    
    onSnapshot(queryErrori, (qs) => {
      this.isLoading = false;
      qs.forEach((doc) => {
          let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
          if(!log.errori || log.errori.length == 0){
            this.messageService.add({severity:'success', summary:'', detail: log.numeroRecordProcessati + ' PRONTOFIBRA processati con successo!', life:10000});
          }else{
            this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento dei PRONTOFIBRA si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
          }
     
        });
    });  
  }

  ngOnChanges(changes: SimpleChanges) {
   
    if (changes['impresa'] && changes['impresa'].currentValue) {
      this.impresa = changes['impresa'].currentValue;
    }
    if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
      this.isImpresa = changes['isImpresa'].currentValue;
    }
    if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
      this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
    }

    if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
      this.loadDatiBando1();
      this.loadDatiBando2();
    }
  }

  loadDatiBando1(){
   /*  if(this.isImpresa){
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 1 PER IMPRESA');
    }else if(this.isPresidioTIM){
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO TIM');
    }else{
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO');
    } */
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_prontofibra).ref;
    let queryBando1  ;
    if(this.isImpresa){
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    ;
     }else{
      queryBando1 = collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("codiceStatoInfratelFase1", "!=", "1-6")
              ;
    }
    onSnapshot(queryBando1, (qs) => {
      this.isLoading = false;
      this.resetBando1();
      this.bando1 = qs.docs.length;
        qs.forEach((doc) => {
          let pfDaFirestore: Prontofibra_Firestore = doc.data() as Prontofibra_Firestore;

          switch (pfDaFirestore.codiceStatoProntofibra) {
            case 'IN ATTESA':
              this.bando1InAttesa++;
              //this.bando1InLavorazione++;
              if(pfDaFirestore.lotto==='6'){
                this.bando1InAttesa_lotto6++;
              }else{
                this.bando1InAttesa_lotto7++;
              }
              break;
            case 'KO':
                this.bando1KO++;
                this.bando1InLavorazione++;
                if(pfDaFirestore.lotto==='6'){
                  this.bando1KO_lotto6++;
                }else{
                  this.bando1KO_lotto7++;
                }
                break;
            case 'PRONTO':
              this.bando1Pronte++;
              this.bando1InLavorazione++;
              if(pfDaFirestore.lotto==='6'){
                this.bando1Pronte_lotto6++;
              }else{
                this.bando1Pronte_lotto7++;
              }
              break;
            case 'ROUTER INSTALLATO':
              this.bando1RouterInstallato++;
              this.bando1InLavorazione++;
              if(pfDaFirestore.lotto==='6'){
                this.bando1RouterInstallato_lotto6++;
              }else{
                this.bando1RouterInstallato_lotto7++;
              }
              break;
            case 'SEDE ATTIVATA':
              this.bando1Attivate++;
              //this.bando1InLavorazione++;

              if(pfDaFirestore.lotto==='6'){
                this.bando1Attivate_lotto6++;
              }else{
                this.bando1Attivate_lotto7++;
              }
              break;
            default:
              break;
          }
        });
    });
  }

  resetBando1(){
    this.bando1=0;
    this.bando1InLavorazione=0;

    this.bando1InAttesa = 0;
    this.bando1InAttesa_lotto6 = 0;
    this.bando1InAttesa_lotto7 = 0;

    this.bando1KO = 0;
    this.bando1KO_lotto6 = 0;
    this.bando1KO_lotto7 = 0;

    this.bando1Pronte = 0;
    this.bando1Pronte_lotto6 = 0;
    this.bando1Pronte_lotto7 = 0;
    
    this.bando1RouterInstallato = 0;
    this.bando1RouterInstallato_lotto6 = 0;
    this.bando1RouterInstallato_lotto7 = 0;

    this.bando1Attivate = 0;
    this.bando1Attivate_lotto6 = 0;
    this.bando1Attivate_lotto7 = 0;

  }
  resetBando2(){
    this.bando2InAttesa = 0;
    this.bando2InAttesa_lotto1 = 0;
    this.bando2InAttesa_lotto5 = 0;
    this.bando2InAttesa_lotto7 = 0;
    this.bando2InAttesa_lotto8 = 0;

    this.bando2KO = 0;
    this.bando2KO_lotto1 = 0;
    this.bando2KO_lotto5 = 0;
    this.bando2KO_lotto7 = 0;
    this.bando2KO_lotto8 = 0;

    this.bando2Pronte = 0;
    this.bando2Pronte_lotto1 = 0;
    this.bando2Pronte_lotto5 = 0;
    this.bando2Pronte_lotto7 = 0;
    this.bando2Pronte_lotto8 = 0;

    this.bando2RouterInstallato = 0;
    this.bando2RouterInstallato_lotto1 = 0;
    this.bando2RouterInstallato_lotto5 = 0;
    this.bando2RouterInstallato_lotto7 = 0;
    this.bando2RouterInstallato_lotto8 = 0;

    this.bando2Attivate = 0;
    this.bando2Attivate_lotto1 = 0;
    this.bando2Attivate_lotto5 = 0;
    this.bando2Attivate_lotto7 = 0;
    this.bando2Attivate_lotto8 = 0;
    this.bando2InLavorazione= 0;
    this.bando2= 0;
  }

  loadDatiBando2(){
    /* if(this.isImpresa){
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 2 PER IMPRESA');
    }else if(this.isPresidioTIM){
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO TIM');
    }else{
      this.logger.info('[PF] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO');
    } */
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_prontofibra).ref;
    let queryBando2  ;
    if(this.isImpresa){
     queryBando2 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2");
    }else{
      queryBando2 = collectionRef
              .where("bando", "==", "BANDO 2");
             
    }

    onSnapshot(queryBando2, (qs) => {
      this.isLoading = false;
      this.resetBando2();
      this.bando2 = qs.docs.length;
      qs.forEach((doc) => {
        let pfDaFirestore: Prontofibra_Firestore = doc.data() as Prontofibra_Firestore;
        switch (pfDaFirestore.codiceStatoProntofibra) {
          case 'IN ATTESA':
            this.bando2InAttesa++;
            if(pfDaFirestore.lotto==='1'){
              this.bando2InAttesa_lotto1++;
            }else if(pfDaFirestore.lotto==='5'){
              this.bando2InAttesa_lotto5++;
            }else if(pfDaFirestore.lotto==='7'){
              this.bando2InAttesa_lotto7++;
            }else {
              this.bando2InAttesa_lotto8++;
            }
            break;
            case 'KO':
              this.bando2InLavorazione++;
              this.bando2KO++;
              if(pfDaFirestore.lotto==='1'){
                this.bando2KO_lotto1++;
              }else if(pfDaFirestore.lotto==='5'){
                this.bando2KO_lotto5++;
              }else if(pfDaFirestore.lotto==='7'){
                this.bando2KO_lotto7++;
              }else {
                this.bando2KO_lotto8++;
              }
              break;   
          case 'PRONTO':
            this.bando2Pronte++;
            this.bando2InLavorazione++;
            if(pfDaFirestore.lotto==='1'){
              this.bando2Pronte_lotto1++;
            }else if(pfDaFirestore.lotto==='5'){
              this.bando2Pronte_lotto5++;
            }else if(pfDaFirestore.lotto==='7'){
              this.bando2Pronte_lotto7++;
            }else {
              this.bando2Pronte_lotto8++;
            }
            break;
          case 'ROUTER INSTALLATO':
            this.bando2RouterInstallato++;
            this.bando2InLavorazione++;
            if(pfDaFirestore.lotto==='1'){
              this.bando2RouterInstallato_lotto1++;
            }else if(pfDaFirestore.lotto==='5'){
              this.bando2RouterInstallato_lotto5++;
            }else if(pfDaFirestore.lotto==='7'){
              this.bando2RouterInstallato_lotto7++;
            }else {
              this.bando2RouterInstallato_lotto8++;
            }
            break;
          case 'SEDE ATTIVATA':
            this.bando2Attivate++;
           // this.bando2InLavorazione++;

            if(pfDaFirestore.lotto==='1'){
              this.bando2Attivate_lotto1++;
            }else if(pfDaFirestore.lotto==='5'){
              this.bando2Attivate_lotto5++;
            }else if(pfDaFirestore.lotto==='7'){
              this.bando2Attivate_lotto7++;
            }else {
              this.bando2Attivate_lotto8++;
            }
            break;
          default:
            break;
        }
        
      });
    });
  }

  aggiornaPratiche(n:number){

  }

  openProntofibra(bando:number, stato:string, lotto:number){
    if(lotto){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
        {
          queryParams: { 
              'bando': bando,
              'stato': stato, 
              'lotto': lotto}, 
        })
      );
    }else{
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
        {
          queryParams: { 
              'bando': bando,
              'stato': stato}, 
        })
      );
    }
  }
  openAllPF(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
      {
        queryParams: { 
            'bando': bando,
        }
      })
    );
  }
  openPFInLavorazione(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['prontofibra'],
      {
        queryParams: { 
            'bando': bando,
            'in-lavorazione': true
        }
      })
    );
  }

  importaPF(){
    this.importID = uuidv4();
    this.csvbox_importer_aggiornamentoPF.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_aggiornamentoPF.openModal();
  }


  
  


  
}
